import { tempestPlugin } from '../modules/globals';

const clsSectionHeader = tempestPlugin === 'map_plugin' ?
    'section-header theme-section-background':
    'section-header theme-section-background text-uppercase';

const clsSectionHeaderOld = tempestPlugin === 'map_plugin' ?
    'dlgModelSectionHeader theme-section-background accordion-header ios-clickable' :
    'dlgModelSectionHeader theme-section-background accordion-header ios-clickable text-uppercase';

const clsPanelButtonOuter = 'panel-button-outer';

const clsPanelButtonInner = tempestPlugin === 'map_plugin' ?
    'panel-button-inner' :
    'panel-button-inner text-uppercase';

const clsPanelButtonText = tempestPlugin === 'map_plugin' ?
    'panel-button-text' :
    'panel-button-text text-uppercase';

export {
  clsSectionHeader,
  clsSectionHeaderOld,
  clsPanelButtonOuter,
  clsPanelButtonInner,
  clsPanelButtonText
};